import { createSelector } from '@reduxjs/toolkit';
import { networksNotDeleted } from './networks-not-deleted';
import { computersForMap } from './computers-for-map';
import type { NetworkViewModel, PersonalDataItemViewModel } from '@trinnvis/dabih-api-client';
import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { computersInNetwork } from './computers-in-network';
import { alertsForNetwork } from './alerts-for-network';
import { firstBy } from 'thenby';
import { networkHasPersonalDataItems } from './network-has-personal-data-items';

export const networksForMap = createSelector(networksNotDeleted, computersForMap, function (networks, computers) {
  let map: (NetworkViewModel & { computers: ComputerViewModelExtended[]; alerts: string[] })[] = networks.map((c) =>
    Object.assign({}, c, {
      computers: computersInNetwork(computers, c.uuid),
      alerts: [],
    }),
  );
  map = map.map(function (c) {
    return Object.assign({}, c, { alerts: alertsForNetwork(c) });
  });
  return map.sort(
    firstBy(function (
      v: NetworkViewModel & {
        computers: { personalDataItems: PersonalDataItemViewModel[] }[];
      },
    ) {
      return networkHasPersonalDataItems(v) ? 0 : 1;
    })
      .thenBy('name', { ignoreCase: true })
      .thenBy('uuid'),
  );
});
